"use client";

import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { cicToType } from "@/helpers/Helpers";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import WaveDropAuthorPfp from "@/components/waves/drops/WaveDropAuthorPfp";
import { ExtendedDrop } from "@/helpers/waves/drop.helpers";
import WinnerDropBadge from "@/components/waves/drops/winner/WinnerDropBadge";
import WaveDropTime from "@/components/waves/drops/time/WaveDropTime";
import UserProfileTooltipWrapper from "@/components/utils/tooltip/UserProfileTooltipWrapper";
import { ArtistSubmissionBadge } from "@/components/waves/drops/ArtistSubmissionBadge";
import { ArtistPreviewModal } from "@/components/waves/drops/ArtistPreviewModal";
import { ProfileWinnerBadge } from "@/components/waves/drops/ProfileWinnerBadge";
import { useArtistPreviewModal } from "@/hooks/useArtistPreviewModal";
interface MemesLeaderboardDropArtistInfoProps {
  readonly drop: ExtendedDrop;
}
const MemesLeaderboardDropArtistInfo = t0 => {
  const $ = _c(42);
  const {
    drop
  } = t0;
  const {
    isModalOpen,
    modalInitialTab,
    handleBadgeClick,
    handleModalClose
  } = useArtistPreviewModal();
  const submissionCount = drop.author.active_main_stage_submission_ids?.length || 0;
  const hasSubmissions = submissionCount > 0;
  const winnerCount = drop.author.winner_main_stage_drop_ids?.length || 0;
  const isWinner = winnerCount > 0;
  let t1;
  if ($[0] !== drop) {
    t1 = <WaveDropAuthorPfp drop={drop} />;
    $[0] = drop;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== drop.author.cic || $[3] !== drop.author.level) {
    t2 = !!drop.author?.level && <UserCICAndLevel level={drop.author.level} cicType={cicToType(drop.author.cic)} size={UserCICAndLevelSize.SMALL} />;
    $[2] = drop.author.cic;
    $[3] = drop.author.level;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== drop.author.handle || $[6] !== drop.author.id) {
    t3 = drop.author?.handle ? <UserProfileTooltipWrapper user={drop.author.handle ?? drop.author.id}><Link href={`/${drop.author?.handle}`} onClick={_temp} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author?.handle}</span></Link></UserProfileTooltipWrapper> : <Link href={`/${drop.author?.handle}`} onClick={_temp2} className="tw-no-underline desktop-hover:hover:tw-underline"><span className="tw-text-sm tw-font-bold tw-text-white">{drop.author?.handle}</span></Link>;
    $[5] = drop.author.handle;
    $[6] = drop.author.id;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  let t4;
  if ($[8] !== drop.id || $[9] !== handleBadgeClick || $[10] !== isWinner || $[11] !== winnerCount) {
    t4 = isWinner && <ProfileWinnerBadge winCount={winnerCount} onBadgeClick={() => handleBadgeClick("winners")} tooltipId={`leaderboard-winner-badge-${drop.id}`} />;
    $[8] = drop.id;
    $[9] = handleBadgeClick;
    $[10] = isWinner;
    $[11] = winnerCount;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== drop.id || $[14] !== handleBadgeClick || $[15] !== hasSubmissions || $[16] !== submissionCount) {
    t5 = hasSubmissions && <ArtistSubmissionBadge submissionCount={submissionCount} onBadgeClick={() => handleBadgeClick("active")} tooltipId={`leaderboard-badge-${drop.id}`} />;
    $[13] = drop.id;
    $[14] = handleBadgeClick;
    $[15] = hasSubmissions;
    $[16] = submissionCount;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  let t6;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="tw-text-sm tw-text-iron-500">•</span>;
    $[18] = t6;
  } else {
    t6 = $[18];
  }
  let t7;
  if ($[19] !== drop.created_at) {
    t7 = <WaveDropTime timestamp={drop.created_at} />;
    $[19] = drop.created_at;
    $[20] = t7;
  } else {
    t7 = $[20];
  }
  let t8;
  if ($[21] !== t2 || $[22] !== t3 || $[23] !== t4 || $[24] !== t5 || $[25] !== t7) {
    t8 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-flex-wrap -tw-mt-0.5">{t2}{t3}{t4}{t5}{t6}{t7}</div>;
    $[21] = t2;
    $[22] = t3;
    $[23] = t4;
    $[24] = t5;
    $[25] = t7;
    $[26] = t8;
  } else {
    t8 = $[26];
  }
  const t9 = drop.winning_context?.decision_time || null;
  let t10;
  if ($[27] !== drop.rank || $[28] !== t9) {
    t10 = <div className="tw-flex tw-items-center tw-gap-x-2"><WinnerDropBadge rank={drop.rank} decisionTime={t9} /></div>;
    $[27] = drop.rank;
    $[28] = t9;
    $[29] = t10;
  } else {
    t10 = $[29];
  }
  let t11;
  if ($[30] !== t10 || $[31] !== t8) {
    t11 = <div className="tw-flex tw-flex-col tw-justify-between tw-h-12">{t8}{t10}</div>;
    $[30] = t10;
    $[31] = t8;
    $[32] = t11;
  } else {
    t11 = $[32];
  }
  let t12;
  if ($[33] !== drop.author || $[34] !== handleModalClose || $[35] !== isModalOpen || $[36] !== modalInitialTab) {
    t12 = <ArtistPreviewModal isOpen={isModalOpen} onClose={handleModalClose} user={drop.author} initialTab={modalInitialTab} />;
    $[33] = drop.author;
    $[34] = handleModalClose;
    $[35] = isModalOpen;
    $[36] = modalInitialTab;
    $[37] = t12;
  } else {
    t12 = $[37];
  }
  let t13;
  if ($[38] !== t1 || $[39] !== t11 || $[40] !== t12) {
    t13 = <div className="tw-flex tw-gap-x-3">{t1}{t11}{t12}</div>;
    $[38] = t1;
    $[39] = t11;
    $[40] = t12;
    $[41] = t13;
  } else {
    t13 = $[41];
  }
  return t13;
};
export default MemesLeaderboardDropArtistInfo;
function _temp(e) {
  return e.stopPropagation();
}
function _temp2(e_0) {
  return e_0.stopPropagation();
}